<template>
  <section
    class="hero is-link is-fullheight-with-navbar"
    style="
      background-size: cover;
      background-position: center;
    "
    :style="{
      'background-image': 'url(' + dunes + ')'
    }"
  >
    <container-box>
      <form @submit.prevent="submit">
        <label class="label is-large">Connexion</label>
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="email"
              placeholder="Email"
              v-model="email"
              autocomplete="email"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-envelope"></i>
            </span>
            <span class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input
              class="input"
              type="password"
              placeholder="Password"
              v-model="password"
              autocomplete="current-password"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-lock"></i>
            </span>
          </p>
        </div>
        <div class="field is-grouped">
          <p class="control">
            <button
              class="button is-primary"
              :class="{ 'is-loading': isLoading }"
            >
              Connexion
            </button>
          </p>
          <p class="control">
            <router-link class="button is-light" :to="{ name: 'Reset' }">
              Réinitialiser l'accès
            </router-link>
          </p>
        </div>
      </form>
      <br />
      <transition name="fade">
        <article
          v-if="isLogin"
          class="message"
          :class="[isSuccess ? 'is-success' : 'is-danger']"
        >
          <div class="message-body">
            <template v-if="isSuccess">
              <strong>Connexion établies !</strong>
              <br />
              Vous allez être redirigé sous peu.
            </template>
            <template v-else>
              <strong>Une erreur est survenue</strong>
              <br />
              {{ error }}
            </template>
          </div>
        </article>
      </transition>
    </container-box>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import purpleDunes from "@/assets/purpleDunes.svg";
import ContainerBox from "@/components/ContainerBox";

export default {
  components: { ContainerBox },
  data() {
    return {
      dunes: purpleDunes,
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapActions("auth", ["logIn", "reinitialize"]),
    submit() {
      const data = {
        email: this.email,
        password: this.password
      };
      this.logIn(data);
    }
  },
  computed: {
    ...mapGetters("auth", [
      "verified",
      "status",
      "referrer",
      "isLogin",
      "error",
      "isLoading"
    ]),
    isSuccess() {
      return this.status === 200;
    }
  },
  watch: {
    status() {
      if (this.isLogin && this.isSuccess) {
        if (this.referrer !== "") {
          const location = this.referrer;
          localStorage.removeItem("referrer");
          this.reinitialize();
          document.location.href = location;
          return;
        }
        setTimeout(() => this.$router.push({ name: "Portal" }), 1000);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
